import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { SOCIALS, sitePage, siteUrl } from '../pixmmoLinks';
const t = key => app.translator.trans(`soup-97-pixmmo-pixelui.forum.footer.${key}`);

/**
 * PixMMO's site footer (src/components/Footer.tsx in the game) for the forum:
 * the same columns, socials and legal links, pointing at the PixMMO website.
 * Rendered into Flarum's #footer (core's Footer component renders nothing).
 */
export default class PxFooter extends Component {
  view() {
    const site = siteUrl();
    const page = sitePage;
    const link = (href, label) => m("li", null, m("a", {
      href: href,
      target: "_blank",
      rel: "noopener noreferrer"
    }, label));
    return m("div", {
      className: "PxFooter"
    }, m("div", {
      className: "PxFooter-main container"
    }, m("div", {
      className: "PxFooter-brand"
    }, m("a", {
      className: "PxFooter-logo",
      href: site,
      target: "_blank",
      rel: "noopener noreferrer"
    }, m("img", {
      src: page('/logo/pixmmo-logo.png'),
      alt: "",
      width: "32",
      height: "32"
    }), m("span", null, "Pix", m("span", {
      className: "PxFooter-logoAccent"
    }, "MMO"))), m("p", null, t('tagline')), m("div", {
      className: "PxFooter-socials"
    }, SOCIALS.map(social => m("a", {
      href: social.href,
      target: "_blank",
      rel: "noopener noreferrer",
      title: social.label,
      "aria-label": social.label
    }, m("i", {
      className: `icon ${social.icon}`,
      "aria-hidden": "true"
    }))))), m("nav", {
      className: "PxFooter-column",
      "aria-label": t('play')
    }, m("h4", null, t('play')), m("ul", null, link(page('/game'), t('play_now')), link(page('/news'), t('news')), link(page('/roadmap'), t('roadmap')), link(page('/wiki'), t('wiki')), link(page('/game/players'), t('leaderboard')), link(page('/killboard'), t('killboard')))), m("nav", {
      className: "PxFooter-column",
      "aria-label": t('community')
    }, m("h4", null, t('community')), m("ul", null, SOCIALS.map(social => link(social.href, social.label)), link(page('/careers'), t('careers')))), m("nav", {
      className: "PxFooter-column",
      "aria-label": t('legal')
    }, m("h4", null, t('legal')), m("ul", null, link(page('/impressum'), t('legal_notice')), link(page('/privacy-policy'), t('privacy')), link(page('/game-rules'), t('game_rules')), link(page('/terms'), t('terms')), link(page('/cancel-contracts'), t('cancel_contracts'))))), m("div", {
      className: "PxFooter-bottom"
    }, m("div", {
      className: "container"
    }, m("p", null, app.translator.trans('soup-97-pixmmo-pixelui.forum.footer.copyright', {
      year: new Date().getFullYear()
    })), m("p", null, t('published_by'), ' ', m("a", {
      href: "https://utherstudios.com",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Uther Studios")))));
  }
}
flarum.reg.add('soup-97-pixmmo-pixelui', 'forum/components/PxFooter', PxFooter);